import { render, staticRenderFns } from "./shop-compensate.vue?vue&type=template&id=d0f87a34&"
import script from "./shop-compensate.vue?vue&type=script&lang=js&"
export * from "./shop-compensate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports